var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.submit()
        }
      }
    },
    [
      _c("step-text", [
        _vm._v(
          "Toda empresa tem um representante legal, precisamos que você nos informe os dados do seu representante:"
        )
      ]),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|min:2|max:64|alpha_spaces",
            expression: "'required|min:2|max:64|alpha_spaces'"
          }
        ],
        attrs: {
          error: _vm.errors.first("Nome"),
          label: "Nome",
          "custom-classes": "capitalize"
        },
        model: {
          value: _vm.first_name,
          callback: function($$v) {
            _vm.first_name = $$v
          },
          expression: "first_name"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|min:2|max:64|alpha_spaces",
            expression: "'required|min:2|max:64|alpha_spaces'"
          }
        ],
        attrs: {
          error: _vm.errors.first("Sobrenome"),
          label: "Sobrenome",
          "custom-classes": "capitalize"
        },
        model: {
          value: _vm.last_name,
          callback: function($$v) {
            _vm.last_name = $$v
          },
          expression: "last_name"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|numeric|length:11",
            expression: "'required|numeric|length:11'"
          }
        ],
        attrs: {
          error: _vm.errors.first("cpf"),
          label: "CPF",
          name: "cpf",
          "data-vv-as": "CPF",
          mask: "###.###.###-##"
        },
        model: {
          value: _vm.cpf,
          callback: function($$v) {
            _vm.cpf = $$v
          },
          expression: "cpf"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|date_format:DD/MM/YYYY",
            expression: "'required|date_format:DD/MM/YYYY'"
          }
        ],
        attrs: {
          error: _vm.errors.first("birthdate"),
          masked: true,
          label: "Data de nascimento",
          name: "birthdate",
          "data-vv-as": "Data de nascimento",
          mask: "##/##/####"
        },
        model: {
          value: _vm.birthdate,
          callback: function($$v) {
            _vm.birthdate = $$v
          },
          expression: "birthdate"
        }
      }),
      _vm._v(" "),
      _c("base-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|numeric|min:10|max:11",
            expression: "'required|numeric|min:10|max:11'"
          }
        ],
        attrs: {
          error: _vm.errors.first("Celular"),
          mask: ["(##) ####-####", "(##) #####-####"],
          label: "Celular"
        },
        model: {
          value: _vm.phone,
          callback: function($$v) {
            _vm.phone = $$v
          },
          expression: "phone"
        }
      }),
      _vm._v(" "),
      _c(
        "base-flex",
        { staticClass: "mt-10", attrs: { justify: "end" } },
        [
          _c(
            "base-button",
            {
              attrs: { outlined: "" },
              on: {
                click: function($event) {
                  _vm.prevLegalStep()
                }
              }
            },
            [_vm._v("voltar")]
          ),
          _vm._v(" "),
          _c("base-button", { attrs: { type: "submit" } }, [
            _vm._v("continuar")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01997790", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01997790","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/Steps/Accountable/Types/Legal/Representative.vue
// module id = null
// module chunks = 